<main [ngClass]="{ fullscreen: isFullscreen }">
  <div id="logo-container">
    <div class="full-negative-logo"></div>
  </div>

  @if (showVersion) {
    <p class="version">{{ version }}</p>
  }

  @if (loadingText) {
    <p class="loading-text">{{ loadingText }}</p>
  }

  <div class="progress-bar-wrapper">
    <mat-progress-bar mode="indeterminate" />
  </div>
</main>
